// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'url-polyfill'
import axios from 'axios'
// import devtools from '@vue/devtools'
import isEqual from 'lodash/isEqual'
import range from 'lodash/range'
import Vue from 'vue'
import VueAuth from '@websanova/vue-auth'
import VeeValidate from 'vee-validate'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'
/* eslint-disable */
import Multiselect from 'vue-multiselect'
/* eslint-enable */

import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

import App from './components/App.vue'
import router from './router'
import store from './store'

// Load vue awesome icons
import 'vue-awesome/icons/spinner'
import 'vue-awesome/icons/folder-o'
import 'vue-awesome/icons/minus-square-o'
import 'vue-awesome/icons/plus-square-o'
import 'vue-awesome/icons/download'
import 'vue-awesome/icons/trash-o'
import 'vue-awesome/icons/file-text-o'
import 'vue-awesome/icons/warning'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/exclamation-circle'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/chevron-up'
import 'vue-awesome/icons/question-circle'
import 'vue-awesome/icons/search-plus'
import 'vue-awesome/icons/pencil'

import Icon from 'vue-awesome/components/Icon'

Vue.config.productionTip = false

Vue.component('icon', Icon)

axios.defaults.baseURL = process.env.ADDON_BASE_URL
Vue.axios = axios
Vue.prototype.$http = axios
Vue.prototype.$lodash = { isEqual, range }

Vue.router = router

Vue.use(VeeValidate)
Vue.use(BootstrapVue)
Vue.use(VueAnalytics, {
  id: process.env.GOOGLE_ANALYTICS_ID,
  router
})

// if (process.env.NODE_ENV === 'development') {
//   devtools.connect(/* host, port */)
// }

import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/aui-replacement.css'

// I set loginData fetchUser to false because it was causing api/refresh to get hit before exchange-token
// When my RMcloudJWT was expired, it was then trying to hit /authenticate again without the query params, and failing
// I think the refresh thing is minutes, so I'm setting that to one day.
Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  tokenName: 'rmcloud_token',
  authRedirect: { path: '/authenticate' },
  refreshData: {url: 'api/refresh', interval: 1440},
  loginData: {fetchUser: false},
  fetchData: {url: 'api/user'},
  tokenExpired: function () { return false }
})

// Must run BEFORE the app mounts. Previously this ran after new Vue(), so any
// error thrown during boot happened while the SDK did not yet exist and was
// never reported — the exact class of failure that leaves a blank iframe.
Sentry.init({
  dsn: 'https://4f98df9c817046d2b6c140c71c1f15ec@o395945.ingest.sentry.io/5248638',
  // Baked in at build time from SENTRY_RELEASE (see config/prod.env.js + deploy.sh).
  // Tags every event with the release so Sentry can match uploaded sourcemaps.
  release: process.env.SENTRY_RELEASE || undefined,
  integrations: [new VueIntegration({Vue, attachProps: true, logErrors: true})]
})

// Add vuex state to the sentry errors
Sentry.configureScope(scope => {
  scope.setExtra('vuex', store.state)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js